import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

export default function PageHero({ overline, title, description, testid }) {
  const { pick } = useLang();
  return (
    <section className="relative bg-ngo-forest overflow-hidden">
      <div className="absolute -top-20 right-0 w-96 h-96 rounded-full bg-ngo-deep/50 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-24 relative">
        {overline && (
          <Reveal>
            <p className="text-ngo-gold text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase mb-4">{pick(overline)}</p>
          </Reveal>
        )}
        <Reveal i={1}>
          <h1 data-testid={testid} className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-ngo-cream tracking-tight leading-tight max-w-3xl">
            {pick(title)}
          </h1>
        </Reveal>
        {description && (
          <Reveal i={2}>
            <p className="mt-5 max-w-2xl text-base md:text-lg text-ngo-mint/80 leading-relaxed">{pick(description)}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
